import {
    Box,
    Divider,
    Typography,
} from "@material-ui/core";
import SimpleLabelValue from './Views/SimpleLabelValue';
import SimpleLinkedChip from './Views/SimpleLinkedChip';
import Links from './Views/Links';
import { detailsLabel } from '../../../constants';
import { isValidUrl } from './utils';
import { useSelector } from 'react-redux'


const SampleDetails = (props) => {
    const { node } = props;

    const samplePropertiesModel = useSelector(state => state.sdsState.metadata_model.sample);

    return (
        <Box id={node?.graph_node?.attributes.localId + detailsLabel}>
            <Divider />
            <Box className="tab-content">
                <SimpleLabelValue label={""} value={""} heading={"Sample Details"} />

                {samplePropertiesModel?.map( property => {
                    if ( property.visible || property.visible == undefined ){
                        const propValue = node.graph_node.attributes[property.property]?.[0];
                        if ( isValidUrl(propValue) ){
                            return (<Box className="tab-content-row">
                                <Typography component="label">{property.label}</Typography>
                                <Links key={`detail_links_dataset`} href={propValue} title={property.label + " Link"} />
                            </Box>)
                        }

                        else if ( typeof propValue === "object" ){
                            if ( isValidUrl(node.graph_node.attributes[property.property]?.[0]?.value) ){
                                return (<Box className="tab-content-row">
                                    <Typography component="label">{property.label}</Typography>
                                    <Links key={`detail_links_dataset`} href={node.graph_node.attributes[property.property]?.[0]?.value} title={property.label + " Link"} />
                                </Box>)
                            }
                            else return (<SimpleLabelValue label={property.label} value={node.graph_node.attributes[property.property]?.[0]?.value} />)
                        }

                        else if ( typeof propValue === "string" ){
                            return (<SimpleLabelValue label={property.label} value={propValue} />)
                        }

                        return (<> </>)
                    }
                })}
            </Box>
        </Box>
    );
};

export default SampleDetails;
